import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
  useHandleApiError,
} from '@sttedra_ui/framework';

import ServiceAreaApiResponseModel from './service-area.api-response-model.js';
import HighwayApiResponseModel from './highway.api-response-model.js';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'areaservicio';
const DEFAULT_TIMEOUT = 5000;
const {handleApiError} = useHandleApiError();
// #endregion

// #region Public functions
async function getAllServiceAreaHighways(throwError = true) {
  try {
    const url = '/' + CONTEXT_BASE_PATH + '/gethighway';

    const {data: response} = await base.post(url, {}, {
      timeout: DEFAULT_TIMEOUT,
    });

    const originalData = response;

    const data = originalData.map((u) => new HighwayApiResponseModel(u));

    return {data};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}
async function searchServiceArea(searchParams = {}, throwError = true) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + CONTEXT_BASE_PATH;

    const {data: response} = await base.post(url, searchModel, {
      timeout: DEFAULT_TIMEOUT,
    });

    const {data: originalData, pageSize, pageIndex, totalResults} = response;

    const data = originalData.map((u) => new ServiceAreaApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getAllServiceAreaHighways,
  searchServiceArea,
};
